var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"particles"},[_c('div',{attrs:{"id":"particles-js"}}),_c('main',[_c('Language'),_c('SubHeader'),_c('Hero'),_c('Key'),_c('Cards'),_c('Form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }